<template>
    <div>
        <div v-if="index" class="mb-lg" :class="{ 'account__container py-none': fullWidth }">
            <p class="h4">Inverter {{ parsedIndex }} - {{ systemSize }}</p>
            <SystemFlags :system="system.$model" :temperature="temperature" :building-type="buildingType" @updated="flags = $event" />
            <p v-if="system.$dirty && system.$invalid" class="small semi text--orange">Please complete all information for each MPPT</p>
        </div>

        <slot v-for="(n, diagramIndex) in diagramsToRender" :start-mppt="diagramIndex * mpptsPerDiagram" :mppts-per-diagram="mpptsPerDiagram" :flags="flags" />
    </div>
</template>

<script>
import { get, round } from 'lodash';
import SystemFlags from '@/jobs/new/SystemFlags';
import { calculateSystemSize } from '@/../utils';

export default {
    components: {
        SystemFlags,
    },

    props: {
        index: {
            type: String,
            required: true
        },
        system: {
            type: Object,
            required: true
        },
        buildingType: {
            type: String,
            default: undefined
        },
        temperature: {
            type: Object,
            default: undefined
        },
        fullWidth: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            flags: null
        };
    },

    computed: {
        type() {
            return get(this.system, '$model.inverter.details.inverterType');
        },

        mpptsPerDiagram() {
            return this.type == 'micro' ? 1 : 2;
        },

        diagramsToRender() {
            return Math.ceil(this.system.$model.mppts.length / this.mpptsPerDiagram);
        },

        parsedIndex() {
            return parseInt(this.index) + 1;
        },

        systemSize() {
            const size = calculateSystemSize([this.system.$model]);
            return round(size/1000, 2) + 'kW';
        },
    },
};
</script>

<style lang="scss" scoped>
    .system-diagram {
        position: relative;
        height: 250px;

        @media screen and (max-width: 799px) {
            width: 300px;
            height: 640px;
            margin: 0 auto;
        }

        .system--micro & {
            height: 120px;
        }
    }

</style>
